import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";

class OrdersContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageSize: this.props.pageSize,
      currentPage: 0,
      pageCount: Math.ceil(props.orders.length / this.props.pageSize),
      pageOrders: this.getPageItems(this.props.pageSize, 0)
    };

    setInterval(() => {
      if (this.state.pageCount > 1) {
        if (this.state.currentPage >= this.state.pageCount - 1) {
          this.setState({
            ...this.state,
            currentPage: 0,
            pageOrders: this.getPageItems(this.state.pageSize, 0)
          });
        } else {
          this.setState({
            ...this.state,
            currentPage: this.state.currentPage + 1,
            pageOrders: this.getPageItems(
              this.state.pageSize,
              this.state.currentPage + 1
            )
          });
        }
      } else if (this.state.currentPage !== 0) {
        this.setState({
          ...this.state,
          currentPage: 0,
          pageOrders: this.getPageItems(this.state.pageSize, 0)
        });
      }
    }, 6000);
  }

  getPageItems(pageSize, pageNumber) {
    let pageIndex = pageNumber * pageSize;
    return this.props.orders.slice(pageIndex, pageIndex + pageSize);
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.orders.length !== prevProps.orders.length ||
      JSON.stringify(this.props.orders) !== JSON.stringify(prevProps.orders)
    ) {
      this.setState({
        ...this.state,
        pageCount: Math.ceil(this.props.orders.length / this.state.pageSize),
        pageOrders: this.getPageItems(
          this.state.pageSize,
          this.state.currentPage
        )
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Grid
          container
          alignItems="flex-start"
          direction="column"
          className="orders-container"
        >
          {this.state.pageOrders.map((order, index) => {
            return (
              <Grid
                item
                key={index}
                className={`order-tile ${order.IsFresh ? "fresh" : ""}`}
              >
                {order.OrderNumber}
              </Grid>
            );
          })}
        </Grid>
        {this.state.pageCount > 1 && (
          <Grid container item xs className="page-indicator-container">
            {this.getPageArray().map(pageIndex => (
              <Grid
                item
                xs
                className={`page-indicator ${
                  pageIndex === this.state.currentPage ? "active" : ""
                }`}
              />
            ))}
          </Grid>
        )}
      </React.Fragment>
    );
  }

  getPageArray() {
    let pageArray = [];

    for (let i = 0; i < this.state.pageCount; i++) {
      pageArray.push(i);
    }
    return pageArray;
  }
}

function mapStateToProps(state) {
  return {
    showReadyToPickUpView: state.configuration.showReadyToPickUpView,
    showPreparationView: state.configuration.showPreparationView
  };
}

export default connect(mapStateToProps)(OrdersContainer);



// WEBPACK FOOTER //
// ./src/containers/OrdersContainer.js